import Vue from 'vue'
import App from './App.vue'

import { LayoutPlugin, NavbarPlugin, ButtonPlugin, VBScrollspyPlugin, FormGroupPlugin, FormInputPlugin  } from 'bootstrap-vue'
import '../node_modules/bootstrap/scss/bootstrap.scss'
import '../node_modules/glightbox/dist/css/glightbox.min.css'

//@ts-ignore
import { getAssetURL } from './mixins/getAssetURL'

Vue.config.productionTip = false

Vue.prototype.googleFormHref = 'https://docs.google.com/forms/d/e/1FAIpQLSeLSBHeVdA_NhVUkdlJRR5icmdxCdBBiYC2MfJrWsmbrNWM3A/viewform'

Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin)
Vue.use(ButtonPlugin)
Vue.use(VBScrollspyPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.mixin(getAssetURL)

new Vue({
  render: h => h(App),
}).$mount('#app')
